module.exports = __webpack_public_path__ + "mp.svg?bccdcb5ecffe13079a8077d6cd57263a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mp.svg
// module id = 1251
// module chunks = 0